import React, { useState } from 'react';
import { Menu, MenuItem } from '@mui/material';
import { Modal } from 'react-bootstrap';
import DirectionsCarRoundedIcon from '@mui/icons-material/DirectionsCarRounded';
import RemoveRoadIcon from '@mui/icons-material/RemoveRoad';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import HelpIcon from '@mui/icons-material/Help';
import { t } from '../../i18n/index';
import './RampContextMenu.css';

/**
 * Context menu για τις ράμπες
 */
const RampContextMenu = ({
    contextMenu,
    rampTask,
    language,
    yardBookings,
    yardPositions,
    onClose,
    onUpdateRamp,
    onCancelLoad
}) => {
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const handleLoadDoneClick = () => {
        setShowConfirmModal(true);
    };

    const handleConfirmLoadDone = () => {
        setShowConfirmModal(false);
        onUpdateRamp(true);
        onClose();
    };

    const handleCancelModal = () => {
        setShowConfirmModal(false);
        onClose();
    };

    const handleCancelClick = () => {
        if (contextMenu?.ramp) {
            const rampId = contextMenu.ramp.LOCATIONID;
            const bookingsForRamp = yardBookings.filter(booking =>
                booking.BOOKINGTASKS?.some(task =>
                    task.LOCATIONID === rampId ||
                    task.PENDING_LOCATIONID === rampId
                )
            );
            if (bookingsForRamp.length > 0 && bookingsForRamp[0].BOOKINGTASKS) {
                const taskForRamp = bookingsForRamp[0].BOOKINGTASKS.find(task =>
                    task.LOCATIONID === rampId || task.PENDING_LOCATIONID === rampId
                );
                if (taskForRamp) {
                    onCancelLoad(bookingsForRamp[0].BOOKINGID, taskForRamp.BOOKINGTASKID);
                }
            }
        }
        onClose();
    };

    return (
        <>
            <Menu
                open={Boolean(contextMenu) && !showConfirmModal}
                onClose={onClose}
                anchorReference="anchorPosition"
                anchorPosition={
                    contextMenu
                        ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                        : undefined
                }
                PaperProps={{
                    style: {
                        borderRadius: 8,
                        boxShadow: '0px 3px 10px rgba(0, 0, 0, 0.2)',
                    },
                }}
                onMouseLeave={!showConfirmModal ? onClose : undefined}
            >
                {rampTask ? (
                    <MenuItem onClick={handleLoadDoneClick}>
                        <CheckCircleRoundedIcon fontSize="medium" style={{ marginRight: 10, color: "var(--color-main-background)" }} />
                        {t('yardView.loadDone', language)}
                    </MenuItem>
                ) : (
                    <>
                        <MenuItem onClick={() => { onUpdateRamp(); onClose(); }}>
                            <DirectionsCarRoundedIcon fontSize="medium" style={{ marginRight: 10, color: "var(--color-main-background)" }} />
                            {t('yardView.driverArrived', language)}
                        </MenuItem>
                        <MenuItem onClick={handleCancelClick}>
                            <RemoveRoadIcon fontSize="medium" style={{ marginRight: 10, color: "var(--color-main-background)" }} />
                            {t('yardView.cancelLoading', language)}
                        </MenuItem>
                    </>
                )}
            </Menu>

            <Modal show={showConfirmModal} onHide={handleCancelModal} centered animation={true} backdrop="static">
                <Modal.Header closeButton style={{ borderBottom: "none", paddingBottom: 0 }}>
                </Modal.Header>
                <Modal.Body style={{ borderRadius: '22px', padding: '20px 30px 30px' }}>
                    <div className="confirm-load-modal-container">
                        <HelpIcon style={{
                            fontSize: 130,
                            color: 'var(--color-main-background)',
                            marginBottom: 20,
                            animation: 'scaleIn 0.75s ease-out forwards'
                        }} />
                        <p className="fw-bold">{t('yardView.confirmLoadDoneTitle', language)}</p>
                        <p>{t('yardView.confirmLoadDoneMessage', language)}</p>
                        <div className="confirm-load-btn-container">
                            <button className="modal-btn-primary-app" onClick={handleConfirmLoadDone}>
                                {t('common.confirm', language)}
                            </button>
                            <button className="modal-btn-cancel" onClick={handleCancelModal}>
                                {t('common.cancel', language)}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default RampContextMenu;
